import { DateRangePickerProps } from './types';
import { DayPicker } from 'react-day-picker';
import { styled } from '@mui/system';
import { useTheme } from '@mui/material';
import subMonths from 'date-fns/subMonths';

const CELL_SIZE = 32;

const DateRangePicker = (props: DateRangePickerProps) => {
  const theme = useTheme();

  return (
    <StyledDatePicker
      mode='range'
      defaultMonth={subMonths(new Date(), 1)}
      numberOfMonths={2}
      modifiersStyles={{
        disabled: {
          color: theme.palette.colors.grey[400],
          borderColor: 'transparent',
          cursor: 'default',
        },
      }}
      {...props}
    />
  );
};

const StyledDatePicker = styled(DayPicker)`
  button {
    font-family: Plus Jakarta Sans;
    outline: none;
    background-color: transparent;
    border: 2px solid transparent;
    text-align: center;
    height: ${CELL_SIZE}px;
    width: ${CELL_SIZE}px;
  }

  button:focus {
    border: 2px solid ${({ theme }): string => theme.palette.colors.purple[200]};
  }

  button:active {
    outline: none;
    background: transparent;
    border: 2px solid ${({ theme }): string => theme.palette.primary.main};
  }
  .rdp-table {
    border-spacing: 0;

    .rdp-head {
      &_cell {
        font-weight: 400;
        font-size: 14px;
        color: ${({ theme }): string => theme.palette.colors.grey[600]};
      }
    }

    .rdp-cell {
      height: ${CELL_SIZE}px;
      width: ${CELL_SIZE}px;
      padding: 0;
    }
    .rdp-vhidden {
      display: none;
    }

    .rdp-day:hover {
      border-color: ${({ theme }): string => theme.palette.colors.purple[500]};
      border-radius: 8px;
    }

    .rdp-day_selected {
      color: ${(props): string => props.theme.palette.primary.main};
      background-color: ${({ theme }): string =>
        theme.palette.colors.purple[100]};

      &.rdp-day_range_start {
        border-bottom-left-radius: 8px;
        border-top-left-radius: 8px;
        color: ${({ theme }): string => theme.palette.colors.white};
        background-color: ${({ theme }): string => theme.palette.primary.main};
      }

      &.rdp-day_range_end {
        border-bottom-right-radius: 8px;
        border-top-right-radius: 8px;
        color: ${({ theme }): string => theme.palette.colors.white};
        background-color: ${({ theme }): string => theme.palette.primary.main};
      }
    }
  }
  .rdp-months {
    display: flex;
  }

  .rdp-caption_label {
    margin-bottom: 16px;
  }

  .rdp-caption_start {
    margin-right: 24px;

    .rdp-caption {
      justify-content: flex-end;
      flex-direction: row-reverse;

      &_label {
        margin-right: 32px;
        margin-left: 0;
      }
    }
  }

  .rdp-caption {
    display: flex;
    align-items: center;

    &_label {
      font-size: 14px;
      flex: 1;
      text-align: center;
      margin-left: 32px;
    }
  }

  .rdp-nav {
    &_icon {
      color: ${({ theme }): string => theme.palette.primary.main};
    }
  }

  .rdp-nav:hover {
    background-color: ${({ theme }): string =>
      theme.palette.colors.purple[100]};
  }

  .rdp-button {
    cursor: pointer;
  }
`;

export default DateRangePicker;
